import styled, { css } from 'styled-components';
interface Props {
  isMinWidth?: number;
}

export const DropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const Trigger = styled.div`
  cursor: pointer;
  display: inline-block;
`;

export const DropdownContent = styled.div<Props>`
  display: flex;
  flex-direction: column;
  padding: 12px;
  margin-top: 4px;
  gap: 12px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-modal);
  border-radius: 12px;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 9;
  ${(props: Props) =>
    props.isMinWidth &&
    css`
      min-width: ${props.isMinWidth}px;
    `}
`;
